import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { useAuth } from '../context/AuthContext.jsx';
import { SearchableSelect } from './SearchableSelect.jsx';

export function FaqTemplatesPanel({ clientId, projectId = null }) {
  const { user } = useAuth();
  const caps = user?.capabilities ?? {};
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!caps.manage_client_faq) return;
    apiJson(`/api/admin/clients/${clientId}/faq/templates`)
      .then(setTemplates)
      .catch(() => setTemplates([]));
  }, [clientId, caps.manage_client_faq]);

  if (!caps.manage_client_faq || !templates.length) {
    return null;
  }

  const apply = async () => {
    if (!selected) return;
    setBusy(true);
    setError('');
    setMsg('');
    try {
      const res = await apiJson(`/api/admin/clients/${clientId}/faq/apply-template`, {
        method: 'POST',
        body: { template: selected, project_id: projectId ? Number(projectId) : null },
      });
      setMsg(`Template applied (${res.blocks_created} blocks). Refresh to see content.`);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-card flat" style={{ marginBottom: '1rem' }}>
      <h3 style={{ marginTop: 0 }}>Form templates</h3>
      <p className="muted small">Apply a predefined questionnaire to this {projectId ? 'project' : 'client'}.</p>
      <div className="row-actions" style={{ flexWrap: 'wrap' }}>
        <SearchableSelect value={selected} onChange={(e) => setSelected(e.target.value)}>
          <option value="">Choose template…</option>
          {templates.map((t) => (
            <option key={t.key} value={t.key}>
              {t.label}
            </option>
          ))}
        </SearchableSelect>
        <button type="button" className="btn-secondary" disabled={!selected || busy} onClick={() => void apply()}>
          {busy ? 'Applying…' : 'Apply template'}
        </button>
      </div>
      {msg ? <p className="success">{msg}</p> : null}
      {error ? <p className="err">{error}</p> : null}
    </div>
  );
}
